import { ref, watch, computed } from '@vue/composition-api'

import store from '@/store'
// import { title } from '@core/utils/filter'
import Filter from '@/views/modules/Utils/filters'


import { useUtils } from '@core/libs/i18n'           
               

export default function useDevicesList() {

  const { t } = useUtils()

  const refDeviceListTable = ref(null)

  const tableColumns =ref([
    { key: 'name', sortable: true, label: 'Name'},
    { key: 'type', sortable: true ,label:'type'},
    { key: 'notificators', sortable: true,label:'notificators' },
    { key: 'from', sortable: true ,label:'from'},
    { key: 'to', sortable: true ,label:'to'},
    { key: 'actions' ,label:'actions'},
   
   
  ])

  const perPage = ref(10)
  const totalItems = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  

  const requestStatus = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refDeviceListTable.value ? refDeviceListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalItems.value,
    }
  })

 
  const refetchData = () => {
   refDeviceListTable.value.refresh()
   //tableColumns.value.refresh()
 
  }

  const filter = ref({})

  watch([currentPage, perPage, searchQuery, ], () => {
 
    filter.value = {
    
      ...(searchQuery.value && {q: searchQuery.value})
    }
    
    refetchData();
  })
  



 
  const fetchList = (ctx, callback) => {
   
    requestStatus.value = true
    store
      .dispatch('app-alert/fetchList', {
        q: searchQuery.value,
        length: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        ...filter.value

      })
      .then(response => {
        requestStatus.value = false
      
        const { data } = response.data.alerts
        const { total } = response.data.alerts    
        callback(data)
        totalItems.value = total
      })
      .catch(() => {
        requestStatus.value = false
      })
  }


  return {
    fetchList,
    tableColumns,
    perPage,
    currentPage,
    totalItems,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDeviceListTable,

   

    requestStatus,

    refetchData,

  }
}
